import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';
import { Scripts } from '../../utility/modals';

@Injectable({
  providedIn: 'root'
})
export class VersionupdateService {

  baseproperties: Baseproperties = new Baseproperties();
  downloadexcelformate_text = "Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided."
  refreshfilter = new BehaviorSubject<any>('');
  filtersObservable = new BehaviorSubject<any>(null);
  selecteditems = new BehaviorSubject<any>([]);
  private baseURL = this.baseproperties.gatewayBaseURL;
  constructor(private httpClient: HttpClient) { }

  getVersionById(id): Observable<Scripts> {
    return this.httpClient.get<Scripts>(`${this.baseURL}/common/versionupdate/getversionbyid/${id}`);
  }

  getVersionDataView(id: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/versionupdate/getversiondataview/${id}`);
  }

  modify(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/common/versionupdate/modify`, payload);
  }

  add(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/common/versionupdate/add`, payload);
  }

  exceldatadownload() {
    return this.httpClient.get(`${this.baseURL}/common/versionupdate/exceldatadownload`, { responseType: 'blob' });
  }

  gettabledata(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/common/versionupdate/gettabledata`, payload);
  }

  getCategory(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/versionupdate/getcategory`);
  }

  getproductdatafilter(filterpayload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/common/versionupdate/getproductdatafilter`, filterpayload);
  }

  getversiondatafilter(filterpayload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/common/versionupdate/getversiondatafilter`, filterpayload);
  }

  getcategorydatafilter(filterpayload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/common/versionupdate/getcategorydatafilter`, filterpayload);
  }
  filterrefresh() {
    this.refreshfilter.next('refresh');
  }

  getFilterChange(filterdata) {
    this.filtersObservable.next(filterdata)
  }

  getProducts(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/versionupdate/getproducts`);
  }

  getVersions(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/versionupdate/getversions`);
  }

}
